import { useId } from "react";
import type { ScenarioLever } from "../../../services/api";
import { formatLever } from "../scenarioFormat";
import { normaliseLever } from "../scenarioLayout";

interface LeverControlProps {
  lever: ScenarioLever;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

/** A slider for quick exploration plus a number box for an exact figure. */
export function LeverControl({ lever, value, onChange, disabled }: LeverControlProps) {
  const id = useId();
  const signed = lever.minimum < 0;
  return (
    <div className={`scenario-lever lever-${lever.group}`}>
      <div>
        <label htmlFor={id}>{lever.label}</label>
        <output htmlFor={id}>{formatLever(value, lever.unit, signed)}</output>
      </div>
      <input
        id={id}
        type="range"
        min={lever.minimum}
        max={lever.maximum}
        step={lever.step}
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(normaliseLever(lever, Number(event.target.value)))}
      />
      <div className="lever-footer">
        <span className="scenario-range-labels">
          <span>{formatLever(lever.minimum, lever.unit, signed)}</span>
          <span>{formatLever(lever.maximum, lever.unit, signed)}</span>
        </span>
        <input
          type="number"
          className="lever-exact"
          aria-label={`${lever.label} exact value`}
          min={lever.minimum}
          max={lever.maximum}
          step={lever.step}
          value={value}
          disabled={disabled}
          onChange={(event) => {
            const parsed = Number(event.target.value);
            if (event.target.value !== "" && Number.isFinite(parsed)) {
              onChange(normaliseLever(lever, parsed));
            }
          }}
        />
      </div>
      {lever.help && <small className="lever-help">{lever.help}</small>}
    </div>
  );
}
